export default {
	getStatus(orderStatus) {
		switch (orderStatus) {
			case 'APPLICANT_SUBMITTED':
				return 'Registered'
			case 'SCREEN_CREATED':
			case 'SCREEN_IN_PROCESS':
				return 'In Progress'
			case 'SCREEN_COMPLETED':
			case 'SCREEN_PENDING':
				return 'Report Complete'
			default:
				return 'Registered'
		}
	},
	getProgress(orderStatus) {
		switch (orderStatus) {
			case 'APPLICANT_SUBMITTED':
				return 35
			case 'SCREEN_CREATED':
			case 'SCREEN_IN_PROCESS':
				return 65
			case 'SCREEN_COMPLETED':
			case 'SCREEN_PENDING':
				return 100
			default:
				return 35 // If you are here, you are at least registered
		}
	},
	init(icon_filepath) {
		return {
			name: '',
			id: 0,
			icon_filepath,
			instructors: [],
			sessions: [],
			address: {
				city: '',
				state: 'OR',
				street: '',
				unit: '',
				zip: '',
			},
		}
	},
}
